import { Page } from 'components';
import { useContext } from 'react';
import { Filters, Results } from './components';
import { UsersContext } from './UsersContext';

let Users = () => {
    let { isLoading } = useContext(UsersContext);

    return (
        <Page
            isLoading={isLoading}
            useHeader={true}
            title="Users"
            addNewUrl="/admin/User/addnew"
        >
            <Filters />
            <Results />
        </Page>
    )
}

export default Users;